import React, { Component } from 'react'
// import { render } from "react-dom"

import { Transition } from 'react-spring'

class Contactbox extends Component {
  constructor () {
    super()
    this.state = {
      show: false
    }
    this.toggleShow = this.toggleShow.bind(this)
  }

  toggleShow = () => {
    this.setState({
      show: !this.state.show
    });
  }

  render() {
    const { show } = this.state

    return (
      <div>
      <div id="talkbox">

        <button onClick={this.toggleShow}>{show ? "Let's talk" : "Let's talk"}</button>

        </div>

        <Transition
          items={show}
          from={{ opacity: 0 }}
          enter={{ opacity: 1 }}
          leave={{ opacity: 0 }}>
          {show =>
            show && (props => <div style={props}><Contactdetails /></div>)
          }
        </Transition>

    </div>

     )
  }
}

class Contactdetails extends Component {
  render() {
    return (
      <div id="contact-info">
        <strong>For general enquiries call the office:</strong><br />
        0207 867 3753<br />
        <strong>Or you can email our MD directly:</strong><br />
        <a href="mailto:jamie@makemooreandgroove.com">jamie@makemooreandgroove.com</a>
      </div>
    )
   }
}

export default Contactbox;
